export default __webpack_public_path__ + "static/media/cereal.a71952cc.svg";